// extracted by mini-css-extract-plugin
export default {"audioPlaybackControls":"_2pOPz","audioRecorderContainer":"_39cMe","elapsedTime":"_14fbD","oscilloscope":"_1VOCj"};